import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AUTO_STYLE, keyframes, style } from '@angular/animations';

import { NgStaticAnimationService } from '../../shared/services/static-animation.service';
import { EnumNgEventName } from '../../shared/event-animation.data';
import { INgAnimationStates, INgEffectOptions, INgAnimationTiming } from '../../shared/event-animation.interface';


/**------------------------------------------------------
 * Animation State Definitions
 */
const NG_ANIMATION_STATES: INgAnimationStates = {
	start 	: keyframes([
		style({ visibility: AUTO_STYLE, 'box-shadow': '0 10px 10px -10px #00000080', 'transform' : 'translateY(-5px)', easing: 'ease', offset: 0 }),
		style({ 'box-shadow': 'none', 'transform' : 'scale(1)', easing: 'ease', offset: 1 })
	]),
	end 	: keyframes([
		style({ visibility: AUTO_STYLE, 'transform' : 'scale(1)', easing: 'ease', offset: 0 }),
		style({ 'box-shadow': '0 10px 10px -10px #00000080', 'transform' : 'translateY(-5px)', easing: 'ease', offset: 1 })
	])
};


/**------------------------------------------------------
 * FloatShadow on Event
 */
@Directive({
    selector: '[ngFloatShadowOnEvent]',
    providers: [NgStaticAnimationService],
    standalone: false
})
export class NgFloatShadowOnEventDirective implements OnInit {

	//** Input Decorators */
	@Input('ngFloatShadowOnEvent') effectOptions: Partial<INgEffectOptions> = null!;
	@Input() targetElement: HTMLElement	= null!;

	constructor(
		private elementRef				: ElementRef,
		private staticAnimationService 	: NgStaticAnimationService
	) {}

	//** Setup the Animation */
	ngOnInit(): void {
		this.staticAnimationService.setupAnimation({
			triggerElement	: this.elementRef.nativeElement,
			targetElement	: this.targetElement,
			states			: NG_ANIMATION_STATES,
			event			: this.effectOptions?.event!,
			timing			: {
				duration	: this.effectOptions?.duration,
				delay		: this.effectOptions?.delay
			}
		});
	}
}


/**------------------------------------------------------
 * FloatShadow on Mouse Hover
 */
@Directive({
    selector: '[ngFloatShadowOnMouseHover]',
    providers: [NgStaticAnimationService],
    standalone: false
})
export class NgFloatShadowOnMouseHoverDirective implements OnInit {

	//** Input Decorators */
	@Input('ngFloatShadowOnMouseHover') timingOptions: Partial<INgAnimationTiming> = null!;
	@Input() targetElement: HTMLElement = null!;

	constructor(
		private elementRef				: ElementRef,
		private staticAnimationService 	: NgStaticAnimationService
	) {}

	//** Setup the Animation */
	ngOnInit(): void {
		this.staticAnimationService.setupAnimation({
			triggerElement	: this.elementRef.nativeElement,
			targetElement	: this.targetElement,
			states			: NG_ANIMATION_STATES,
			event			: EnumNgEventName.MouseHover,
			timing			: this.timingOptions
		});
	}
}
